import { Sparkles } from 'lucide-react'

interface ProfileBrandingProps {
  variant?: 'light' | 'dark'
}

export default function ProfileBranding({
  variant = 'light',
}: ProfileBrandingProps) {
  const isDark = variant === 'dark'

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <a
        href="/"
        target="_blank"
        rel="noopener noreferrer"
        className={`flex items-center gap-2 px-4 py-2 rounded-full backdrop-blur-sm transition-all duration-300 hover:scale-105 ${
          isDark
            ? 'bg-white/10 hover:bg-white/20 border border-white/20 text-white/60'
            : 'bg-white hover:bg-gray-50 shadow-md border border-gray-300 text-gray-700 hover:text-gray-900'
        }`}
        title="Create your own professional profile"
      >
        <Sparkles className="w-4 h-4" />
        <span className="text-sm font-medium">Create your own</span>
      </a>
    </div>
  )
}
